import React, { useEffect } from "react";
import _ from "lodash";
import { Link } from "react-router-dom";

import { activeFormatter } from "Utils/Acciones/Acciones";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import Toolbar from "Utils/Toolbar/Toolbar";
import LoadMask from "Utils/LoadMask/LoadMask";
import { tableOptions } from "Utils/tableOptions";
import {
    formatoEmpty,
    formatoAceptaTarjeta,
    formatoMonedaQuetzales,
} from "Utils/CamposComunes";

const ListadoBancos = ({
    listar,
    page,
    data,
    loader = false,
    sortChange,
    eliminar,
    buscar,
    search,
}) => {
    useEffect(() => {
        listar(page);
    }, []);

    const options = _.cloneDeep(tableOptions);
    options.noDataText = loader ? "Cargando..." : options.noDataText;
    options.page = page;
    options.onPageChange = listar;
    options.onSortChange = sortChange;

    return (
        <React.Fragment>
            <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12">
                    <Link
                        className="btn btn-primary mb-sm-10"
                        to="/bancos/crear/"
                    >
                        <em className="fa fa-plus"></em> Agregar Banco
                    </Link>

                    <div className="grid-container">
                        <div className="grid-titulo">
                            <Toolbar
                                titulo={"Bancos"}
                                buscar={buscar}
                                search={search}
                            />
                        </div>
                        <LoadMask loading={loader} dark blur>
                            <BootstrapTable
                                data={loader ? [] : data.results}
                                fetchInfo={{ dataTotalSize: data.count }}
                                options={options}
                                striped
                                hover
                                remote
                                pagination
                            >
                                <TableHeaderColumn
                                    dataField="nombre_banco"
                                    dataSort
                                    dataFormat={formatoEmpty}
                                    // width={"20rem"}
                                >
                                    Nombre
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    dataField="numero_cuenta"
                                    dataSort
                                    dataFormat={formatoEmpty}
                                    // width={"20rem"}
                                >
                                    No. Cuenta
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    dataField="direccion"
                                    dataSort
                                    dataFormat={formatoEmpty}
                                    // width={"20rem"}
                                >
                                    Dirección
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    dataField="observacion"
                                    dataSort
                                    dataFormat={formatoEmpty}
                                    // width={"20rem"}
                                >
                                    Observación
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    dataField="acepta_tarjeta"
                                    dataSort
                                    dataFormat={formatoAceptaTarjeta}
                                    // width={"20rem"}
                                >
                                    Acepta Tarjeta
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    dataField="debito"
                                    dataSort
                                    dataFormat={formatoMonedaQuetzales}
                                    // width={"20rem"}
                                >
                                    Debito
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    dataField="credito"
                                    dataSort
                                    dataFormat={formatoMonedaQuetzales}
                                    // width={"20rem"}
                                >
                                    Crédito
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    dataField="saldo"
                                    dataSort
                                    dataFormat={formatoMonedaQuetzales}
                                    // width={"20rem"}
                                >
                                    Saldo
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    isKey
                                    dataField="id"
                                    dataAlign="center"
                                    dataSort
                                    dataFormat={activeFormatter({
                                        // ver: "/bancos/detalle",
                                        editar: "/bancos/editar",
                                        eliminar,
                                        // adicional: formatoVistaImprimir,
                                    })}
                                    width={"10rem"}
                                >
                                    Acciones
                                </TableHeaderColumn>
                            </BootstrapTable>
                        </LoadMask>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ListadoBancos;
